module.exports = __webpack_public_path__ + "media/images/flags/1x1/lso-5d856daf62f3400a58467f50cd448d0a.svg";